import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  Pageable,
  CfdiCancelMotivoFilterSpec,
  ListCfdiCancelMotivoFilterSpec,
  WrapperPageableResponse
} from './service-common';
import type { CfdiCancelMotivoDTO } from '../core/models';

export type WrapperPageableResponseCfdiCancelMotivoDTO = WrapperPageableResponse<CfdiCancelMotivoDTO>;

@Injectable({
  providedIn: 'root'
})
export class CfdiCancelMotivoService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl;

  search(
    spec: CfdiCancelMotivoFilterSpec = {},
    pageable: Pageable = { page: 0, size: 20 }
  ): Observable<WrapperPageableResponseCfdiCancelMotivoDTO> {
    return this.http.get<WrapperPageableResponseCfdiCancelMotivoDTO>(
      `${this.apiUrl}/cfdi-cancel-motivos`,
      { params: this.toParams(spec, pageable) }
    );
  }

  list(
    spec: ListCfdiCancelMotivoFilterSpec = {},
    pageable: Pageable = { page: 0, size: 50, sort: ['order,asc'] }
  ): Observable<WrapperPageableResponseCfdiCancelMotivoDTO> {
    return this.http.get<WrapperPageableResponseCfdiCancelMotivoDTO>(
      `${this.apiUrl}/cfdi-cancel-motivos/list`,
      { params: this.toParams(spec, pageable) }
    );
  }

  private toParams(
    spec: Record<string, unknown>,
    pageable: Pageable
  ): HttpParams {
    let params = new HttpParams();
    Object.entries(spec).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.append(key, String(value));
      }
    });
    params = params.append('page', String(pageable.page));
    params = params.append('size', String(pageable.size));
    if (pageable.sort?.length) {
      pageable.sort.forEach(s => params = params.append('sort', s));
    }
    return params;
  }
}
